<template>
  <div id="app">
    <div class="overflow-h">
      <router-view></router-view>
    </div>  
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import './scss/screen.scss';

  /* Buttons reset */
  button {
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    background: none;
    outline: 0px !important;
    margin: 0;
    padding: 0;
    color: inherit;
    font-size: inherit;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    touch-action: auto;
    cursor: pointer;
  }
  button:active, button:focus {
    outline: 0px !important;
  }
  body {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue